import React from 'react';
export function GDPRPage() {
  return <div className="min-h-screen bg-[#121212]" data-id="element-2246">
      <div className="pt-6 px-4 md:px-8 pb-4" data-id="element-2247">
        <h1 className="text-[20px] font-semibold text-white tracking-tight" data-id="element-2248">
          GDPR Compliance
        </h1>
      </div>
    </div>;
}